import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const BG_IMAGE = "/images/hero-circuit-board.jpg";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden pt-20"
    >
      {/* Background image at bottom */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${BG_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          filter: "brightness(1.3) saturate(1.4) hue-rotate(10deg)",
          opacity: 0.5,
        }}
      />

      {/* Blue tint overlay */}
      <div className="absolute inset-0 bg-blue-100/30" />

      {/* Gradient overlay: white at top fading to semi-transparent at bottom */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-white/85 to-white/20" />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl mx-auto text-center">
          <div className="space-y-8">
            <p
              data-testid="hero-overline"
              className="text-xs font-bold uppercase tracking-[0.2em] text-[#0047AB] animate-fade-in-up"
            >
              ServiceNow Specialists
            </p>

            <h1
              data-testid="hero-heading"
              className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.95] text-slate-900 animate-fade-in-up animate-delay-100"
            >
              Trusted
              <br />
              Technology
              <br />
              <span className="text-[#0047AB]">Consulting</span>
            </h1>

            <p
              data-testid="hero-description"
              className="text-base md:text-lg text-slate-700 max-w-xl mx-auto leading-relaxed animate-fade-in-up animate-delay-200"
            >
              We are a South Australian company partnering with organisations to deliver
              reliable technology solutions, create measurable value and support long-term
              success.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4 animate-fade-in-up animate-delay-300">
              <Button
                data-testid="hero-contact-button"
                className="bg-[#0047AB] hover:bg-[#003585] text-white rounded-md px-8 py-6 text-sm font-medium transition-all hover:scale-[0.98] inline-flex items-center gap-2 shadow-lg shadow-blue-900/20"
                onClick={() => scrollTo("#contact")}
              >
                Start a Conversation
                <ArrowRight size={16} />
              </Button>
              <Button
                data-testid="hero-services-button"
                variant="outline"
                className="border-slate-300 bg-white/80 backdrop-blur-sm text-slate-700 hover:border-[#0047AB] hover:text-[#0047AB] rounded-md px-8 py-6 text-sm font-medium transition-all"
                onClick={() => scrollTo("#services")}
              >
                Our Services
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
